/**
 * Apply a theme class to the document root and persist it in localStorage.
 * Can be called from anywhere (settings, auth init, etc.)
 */
export function applyTheme(theme: string) {
  const root = document.documentElement;
  root.classList.remove('dark', 'light');

  if (theme === 'system') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    root.classList.add(prefersDark ? 'dark' : 'light');
  } else {
    root.classList.add(theme);
  }

  localStorage.setItem('theme', theme);
}
